import { RuleType } from '../../@types/rule-type';
/**
 * ルールIDを取得する為に指摘メッセージの末尾に :[separator]-id-2
 * のテキストが含まれる為、そこからルールIDとメッセージを取得する為のクラス
 */
export default class RuleDetailsParser {
    rulePaths;
    ruleConfigs;
    static USER_MESSAGE_SEPARATOR = ':user-';
    static CLIENT_ID_MESSAGE_SEPARATOR = ':client-id-';
    static ADMIN_MESSAGE_SEPARATOR = ':id-';
    static USER_EXPECTED_MESSAGE = ':u-detail';
    static CLIENT_EXPECTED_MESSAGE = ':c-detail';
    static ADMIN_EXPECTED_MESSAGE = ':a-detail';
    static MESSAGE_SEPARATORS = [
        RuleDetailsParser.USER_MESSAGE_SEPARATOR,
        RuleDetailsParser.CLIENT_ID_MESSAGE_SEPARATOR,
        RuleDetailsParser.ADMIN_MESSAGE_SEPARATOR
    ];
    constructor(rulePaths, ruleConfigs) {
        this.rulePaths = rulePaths;
        this.ruleConfigs = ruleConfigs;
    }
    /**
     *
     * @param textlintResult
     * @param message
     * @returns メッセージから、指摘情報を取得する
     */
    parseMessageDetails(textlintResult, message) {
        return this.parseMessage(textlintResult.ruleId, message);
    }
    parseMessage(ruleId, message) {
        if (message.includes(RuleDetailsParser.USER_MESSAGE_SEPARATOR)) {
            return this.parseUserMessage(message);
        }
        if (message.includes(RuleDetailsParser.CLIENT_ID_MESSAGE_SEPARATOR)) {
            return this.parseClientMessage(message);
        }
        if (ruleId === 'prh') {
            return this.parseAdminMessage(message);
        }
        return this.parseOtherMessage(ruleId, message);
    }
    // ユーザが作成した辞書のエラーメッセージをパースする
    parseUserMessage(message) {
        message = RuleDetailsParser.removeExpectedIdFromMessage(message);
        return this.parseMessageWithSeparator(message, RuleDetailsParser.USER_MESSAGE_SEPARATOR, 'ユーザー定義', 'user', this.rulePaths.userRuleUrl, false, RuleType.USER_DIC);
    }
    // クライアントが作成した辞書のエラーメッセージをパースする
    parseClientMessage(message) {
        message = RuleDetailsParser.removeExpectedIdFromMessage(message);
        return this.parseMessageWithSeparator(message, RuleDetailsParser.CLIENT_ID_MESSAGE_SEPARATOR, '', '', this.rulePaths.clientOriginalRuleUrl, true, RuleType.CLIENT_DIC);
    }
    // 管理者が作成した辞書のエラーメッセージをパースする
    parseAdminMessage(message) {
        message = RuleDetailsParser.removeExpectedIdFromMessage(message);
        return this.parseMessageWithSeparator(message, RuleDetailsParser.ADMIN_MESSAGE_SEPARATOR, 'prh', 'prh', this.rulePaths.ruleDetailUrl, false, RuleType.ADMIN_DIC);
    }
    parseMessageWithSeparator(message, separator, defaultRuleId, defaultId, baseUrl, isClientDic, ruleType) {
        const [pointOutMessage, ruleId, ruleDtlId] = RuleDetailsParser.splitMessageAndDtlId(message, separator);
        const ruleName = this.ruleConfigs.originalDictionaryIdToNameMap[Number(ruleId)] ?? defaultRuleId;
        const ruleUrl = defaultId == 'user' ? baseUrl : baseUrl + ruleId;
        return {
            ruleName: ruleName,
            ruleId: ruleId,
            ruleDtlId: ruleDtlId,
            uniqueId: ruleId + '-' + ruleDtlId,
            ruleUrl: ruleUrl,
            isClientDic,
            pointOutMessage,
            ruleType,
        };
    }
    // textlintルールに内包されている辞書形式のエラーメッセージをパースする
    parseOtherMessage(ruleId, message) {
        message = RuleDetailsParser.removeExpectedIdFromMessage(message);
        const id = this.ruleConfigs.ruleKeyToIdMap[ruleId] ?? '';
        const pointOutMessage = /:id/.test(message)
            ? message.split(':id-')[0]
            : message;
        const ruleDtlId = 'other';
        return {
            ruleName: this.ruleConfigs.ruleIdToNameMap[Number(id)] ?? '',
            ruleId: id,
            ruleDtlId: ruleDtlId,
            uniqueId: id + '-' + ruleDtlId,
            ruleUrl: this.rulePaths.ruleDetailUrl + id,
            isClientDic: false,
            pointOutMessage,
            ruleType: RuleType.OTHER,
        };
    }
    // expectedに付与した各detail-idを削除する
    static removeExpectedIdFromMessage(message) {
        return message
            .replace(new RegExp(RuleDetailsParser.USER_EXPECTED_MESSAGE + '-\\d+', 'g'), '')
            .replace(new RegExp(RuleDetailsParser.CLIENT_EXPECTED_MESSAGE + '-\\d+', 'g'), '')
            .replace(new RegExp(RuleDetailsParser.ADMIN_EXPECTED_MESSAGE + '-\\d+', 'g'), '');
    }
    static splitMessageAndDtlId(message, separeter) {
        if (!separeter) {
            for (const separator of RuleDetailsParser.MESSAGE_SEPARATORS) {
                if (message.includes(separator)) {
                    separeter = separator;
                    break;
                }
            }
        }
        if (separeter === undefined) {
            return [message];
        }
        message = RuleDetailsParser.removeExpectedIdFromMessage(message);
        const [pointOutMessage, idStr] = message.split(separeter);
        let ruleId = '';
        let ruleDtlId = '';
        if (idStr !== undefined) {
            [ruleId, ruleDtlId] = idStr.split('-');
        }
        if (separeter === RuleDetailsParser.USER_MESSAGE_SEPARATOR) {
            ruleDtlId = 'user';
        }
        return [pointOutMessage, ruleId, ruleDtlId];
    }
}
